/* ===================================================================
   THE FLOAT CLUB — fc-track.js
   Meta Pixel and GA4, wired to the real cart actions.

   This is the job the tracking apps do, without the app. Nothing here
   needs a subscription and nothing sits between you and your data.

   WHY IT MATTERS MORE THAN IT SOUNDS
   Meta cannot optimise a campaign it cannot measure. With no pixel,
   every ad is delivered to whoever is cheapest to reach rather than
   whoever buys, and no sale is ever attributed back. The events below
   are the ones Meta's algorithm actually trains on.

   CONFIGURE: fill in PIXEL_ID and GA4_ID. With both empty this file
   does nothing at all, rather than throwing errors into the console.

   NOT INCLUDED, DELIBERATELY: Conversions API. CAPI needs a server and
   an access token, and a token shipped in front-end JavaScript is a
   token anyone can take and use to poison your ad data. It belongs in
   a serverless function, not here.

   Session-replay / heatmap analytics (Microsoft Clarity) lives in a
   separate file, assets/fc-clarity.js, loaded right after this one.
   Set its CLARITY_ID to switch it on — it is inert with that empty.
=================================================================== */
(function (global) {
  "use strict";

  var PIXEL_ID = "";     // Meta Events Manager > Data sources > your pixel
  var GA4_ID   = "";     // e.g. "G-XXXXXXXXXX"
  var CURRENCY = "USD";

  if (!PIXEL_ID && !GA4_ID) return;

  /* ---- attribution ------------------------------------------------
     Last-touch source from assets/fc-attrib.js, loaded before this
     file. Missing or unavailable is not an error -- events just fire
     without the extra field, same as before this existed. */
  function attribSource() {
    try {
      return (global.FC_ATTRIB && global.FC_ATTRIB.get) ? (global.FC_ATTRIB.get().last || {}).source || "" : "";
    } catch (e) { return ""; }
  }

  /* ---- Meta Pixel ---------------------------------------------- */
  if (PIXEL_ID) {
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    fbq("init", PIXEL_ID);
    var pvSource = attribSource();
    fbq("track", "PageView", pvSource ? { fc_source: pvSource } : {});
  }

  /* ---- GA4 ------------------------------------------------------ */
  if (GA4_ID) {
    var g = document.createElement("script");
    g.async = true;
    g.src = "https://www.googletagmanager.com/gtag/js?id=" + GA4_ID;
    document.head.appendChild(g);
    global.dataLayer = global.dataLayer || [];
    global.gtag = function () { global.dataLayer.push(arguments); };
    gtag("js", new Date());
    gtag("config", GA4_ID);
  }

  function meta(name, data) { if (PIXEL_ID && global.fbq) fbq("track", name, data || {}); }
  function ga(name, data) { if (GA4_ID && global.gtag) gtag("event", name, data || {}); }

  function unit() { return (global.FC && global.FC.unitGBP) || 44.99; }
  function cartValue() {
    if (!global.FC || !global.FC.totalGBP) return unit();
    return Math.round(global.FC.totalGBP() * 100) / 100;
  }
  function cartQty() { return (global.FC && global.FC.totalQty) ? global.FC.totalQty() : 1; }

  /* ---- ViewContent: they landed on the product ------------------ */
  function viewContent() {
    meta("ViewContent", {
      content_name: "The Float Club Vest", content_type: "product",
      content_ids: ["float-club-vest"], value: unit(), currency: CURRENCY
    });
    ga("view_item", {
      currency: CURRENCY, value: unit(),
      items: [{ item_id: "float-club-vest", item_name: "The Float Club Vest", price: unit() }]
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", viewContent);
  else viewContent();

  /* ---- AddToCart and InitiateCheckout ---------------------------
     Bound by delegation to the real controls rather than a separate
     hook, so a markup change cannot silently stop the tracking while
     the button carries on working. */
  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;

    if (e.target.closest('[data-m="sticky-add"], [data-add-to-cart], #fc-add')) {
      setTimeout(function () {
        meta("AddToCart", {
          content_name: "The Float Club Vest", content_type: "product",
          content_ids: ["float-club-vest"], value: cartValue(),
          currency: CURRENCY, num_items: cartQty()
        });
        ga("add_to_cart", {
          currency: CURRENCY, value: cartValue(),
          items: [{ item_id: "float-club-vest", item_name: "The Float Club Vest",
                    price: unit(), quantity: cartQty() }]
        });
      }, 120);
      return;
    }

    if (e.target.closest("#fc-drawer-checkout, [data-checkout]")) {
      var icSource = attribSource();
      meta("InitiateCheckout", {
        content_type: "product", content_ids: ["float-club-vest"],
        value: cartValue(), currency: CURRENCY, num_items: cartQty(),
        fc_source: icSource || undefined
      });
      ga("begin_checkout", {
        currency: CURRENCY, value: cartValue(), fc_source: icSource || undefined,
        items: [{ item_id: "float-club-vest", item_name: "The Float Club Vest",
                  price: unit(), quantity: cartQty() }]
      });
    }
  });

  /* ---- Lead: the popup email capture ---------------------------- */
  document.addEventListener("submit", function (e) {
    if (!e.target.closest) return;
    if (e.target.closest("#fc-pop [data-form]")) {
      meta("Lead", { content_name: "Popup 20% off", value: 0, currency: CURRENCY });
      ga("generate_lead", { currency: CURRENCY, value: 0 });
    }
  });

  /* Purchase fires on Shopify's own checkout, which this file does not
     reach. Add the pixel in Shopify admin under Settings > Customer
     events so the purchase event is recorded server-side by Shopify. */

  global.FC_TRACK = { meta: meta, ga: ga, configured: !!(PIXEL_ID || GA4_ID) };

})(window);
